import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { SignupCompletedComponent } from './signup-completed.component';
import { SignupErrorModule } from '../signup-error/signup-error.module';

@NgModule({
    imports: [CommonModule, TranslateModule, SignupErrorModule],
    declarations: [SignupCompletedComponent],
    exports: [SignupCompletedComponent]
})
export class SignupCompletedModule {}
